import { AsyncState, loadingAsyncState } from 'widgets-for-react'

import { ImageData } from '../../image/imageState'
import { loadKnowledgeHighlight } from './knowledgeHighlightApi'
import { KnowledgeType } from '../knowledgeUtils'

export type KnowledgeHighlight = {
  title: string
  introduction: string
  type: KnowledgeType
  slug: string;
  image: ImageData
}

export type KnowledgeHighlightState = AsyncState<KnowledgeHighlight | undefined>

export const initialKnowledgeHighlightState = (
  id: number
): KnowledgeHighlightState => loadKnowledgeHighlight(id)
